import { ListSubheader, MenuItem } from "@mui/material";
import * as labels from "config.labels";
import React from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

/** Menu items listing enumerations under a heading; selecting one passes its internalName to onSelect. */
const EnumerationPickerItems = ({ enumerations, onSelect, selected }) => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  return [
    <ListSubheader key={"enum-picker-heading"} disableSticky>
      {translateLabels(labels.REPORTS_V3_EXPRESSION_ENUM_PICKER_HEADING, {
        default: "Values",
      })}
    </ListSubheader>,
    ...enumerations.map((enumeration) => {
      const label = enumeration.displayName ?? String(enumeration.internalName);
      return (
        <MenuItem
          key={label}
          dense
          selected={enumeration.internalName === selected}
          onClick={() => onSelect(enumeration.internalName)}
        >
          {label}
        </MenuItem>
      );
    }),
  ];
};

export default EnumerationPickerItems;
